import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgUndefined = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M12 22q10 0 10-10T12 2 2 12t10 10M9.25 6.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M16.5 16a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2v-2.5a1 1 0 0 1-.447-1.894l1-.5A1 1 0 0 1 15.5 11v4a1 1 0 0 1 1 1m-8.894-4.053a1 1 0 0 0 .894.553V15a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2v-4a1 1 0 0 0-1.447-.894l-1 .5a1 1 0 0 0-.447 1.341M13 7.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgUndefined)
export default ForwardRef
